export enum Language {
    NL = 'nl',
    FR = 'fr',
    DE = 'de',
    EN = 'en',
}

export function getLocalizedLanguages(): Record<Language, string> {
    return {
        nl: $localize`:@@language.nl:Nederlands`,
        fr: $localize`:@@language.fr:Frans`,
        de: $localize`:@@language.de:Duits`,
        en: $localize`:@@language.en:Engels`,
    };
}
